// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_least_exp_first = /** @type {(inputs: {}) => string} */ () => {
	return `least expensive first`
};

const el_least_exp_first = /** @type {(inputs: {}) => string} */ () => {
	return `φθηνότερα πρώτα`
};

const ru_least_exp_first = /** @type {(inputs: {}) => string} */ () => {
	return `сначала дешевле`
};

const he_least_exp_first = /** @type {(inputs: {}) => string} */ () => {
	return `זול יותר קודם`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const least_exp_first = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.least_exp_first(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("least_exp_first", locale)
	if (locale === "en") return en_least_exp_first(inputs)
	if (locale === "el") return el_least_exp_first(inputs)
	if (locale === "ru") return ru_least_exp_first(inputs)
	if (locale === "he") return he_least_exp_first(inputs)
	return "least_exp_first"
};